<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <v-card>
          <template>
            <v-toolbar color="primary" dark>
              <v-toolbar-title class="white--text">Admins</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn flat v-on:click="addVendor()">Add New</v-btn>
              </v-toolbar-items>
            </v-toolbar>
          </template>
          <v-card-text style="padding: 0">
            <v-toolbar
              flat
              color="white"
              dense
              style="margin-bottom: 0px; margin-top: 0px"
            >
              <v-btn
                color="blue"
                :disabled="selected.length != 1"
                small
                @click="editVendor()"
                class="white--text"
                ><v-icon>mdi-pencil</v-icon>edit</v-btn
              >
              <v-btn
                color="red"
                :disabled="selected.length != 1"
                small
                @click="deleteVendor()"
                class="white--text"
                ><v-icon>mdi-delete</v-icon>delete</v-btn
              >
              <v-spacer></v-spacer>
              <div style="width: 200px">
                <v-text-field
                  v-model="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </div>
            </v-toolbar>
            <v-data-table
              :headers="headers"
              v-model="selected"
              :items="vendors"
              :search="search"
              dense
              item-key="id"
              show-select
            >
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="
                    subheading
                    font-weight-light
                    text-primary text--darken-3
                  "
                  v-text="header.text"
                />
              </template>

              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    v-model="props.selected"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </td>
                <td>{{ props.index + 1 }}</td>
                <td>{{ props.item.app_name }}</td>
                <td>{{ props.item.type }}</td>
                <td>{{ props.item.contact }}</td>
                <td>{{ props.item.email }}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline text-primary" v-if="mode == 'insert'"
              >New Vendor</span
            >
            <span class="headline text-primary" v-else>Update Vendor</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-layout row wrap>
                <v-flex xs3> Application Type </v-flex>
                <v-flex xs9>
                  <v-select
                    :items="['ecommerce', 'grocery']"
                    v-model="config.type"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs3> Application Name </v-flex>
                <v-flex xs9>
                  <v-text-field
                    placeholder="App Name"
                    v-model="config.app_name"
                    :rules="rules.required"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3> Delivery Threshold </v-flex>
                <v-flex xs9>
                  <v-text-field
                    placeholder="Delivery Threshold"
                    v-model.number="config.deliveryThreshold"
                    :rules="rules.number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3> Delivery Charge </v-flex>
                <v-flex xs9>
                  <v-text-field
                    placeholder="Delivery Charge"
                    v-model.number="config.deliveryCharge"
                    :rules="rules.number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3> Delivery Timeslots </v-flex>
                <v-flex xs9>
                  <v-combobox
                    multiple
                    v-model="config.timeslots"
                    label="Timeslots"
                    append-icon
                    chips
                    deletable-chips
                    class="tag-input"
                    :search-input.sync="timeslot"
                    @keyup.tab="updateSlots"
                    @paste="updateSlots"
                  >
                  </v-combobox>
                </v-flex>
                <v-flex xs3> Minimum Order Amount </v-flex>
                <v-flex xs9>
                  <v-text-field
                    placeholder="Minimum Order Amount"
                    v-model.number="config.minimumOrderAmount"
                    :rules="rules.number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3> Same Day Delivery </v-flex>
                <v-flex xs9>
                  <v-switch
                    v-model="config.sameDayDelivery"
                    color="success"
                  ></v-switch>
                </v-flex>
                <v-flex xs3> Contact </v-flex>
                <v-flex xs9>
                  <v-text-field
                    placeholder="Contact"
                    v-model.number="config.contact"
                    :rules="rules.contact"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3> Instagram </v-flex>
                <v-flex xs9>
                  <v-text-field
                    placeholder="Instagram"
                    v-model.number="config.instagram"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3> Facebook </v-flex>
                <v-flex xs9>
                  <v-text-field
                    placeholder="Facebook"
                    v-model.number="config.facebook"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3> Mail </v-flex>
                <v-flex xs9>
                  <v-text-field
                    placeholder="Mail Address"
                    v-model.number="config.mail"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3> View Type </v-flex>
                <v-flex xs9>
                  <v-select :items="['grid', 'list']" v-model="config.view">
                  </v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" flat @click.native="dialog = false"
              >Close</v-btn
            >
            <v-btn
              v-if="mode == 'insert'"
              color="blue darken-1"
              :disabled="!valid"
              flat
              @click.native="insertVendor()"
              >Save</v-btn
            >
            <v-btn
              v-else
              color="primary darken-1"
              :disabled="!valid"
              flat
              @click.native="updateVendor()"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<style type="text/css"></style>
<script>
import api from '../api';
export default {
  data: () => ({
    search: '',
    selected: [],
    headers: [],
    valid: false,
    dialog: false,
    admin: {},
    mode: 'insert',
    vendors: [],
    timeslot: '',
    config: {
      app_name: '',
      deliveryCharge: 0,
      deliveryThreshold: 0,
      minimumOrderAmount: 0,
      contact: '',
      facebook: '',
      instagram: '',
      mail: '',
      linkedIn: '',
      timeslots: [],
      addresses: [],
      holidays: [],
      type: 'grocery',
      sameDayDelivery: false,
      cod: true,
      view: 'grid',
    },
    rules: {
      required: [v => /^(?!\s*$).+/.test(v) || 'Name is required'],
      contact: [v => /^[6-9]\d{9}$/.test(v) || !v || 'Invalid Phone Number'],
      number: [v => /^[0-9]+$/.test(v) || 'Only digits are allowed'],
    },
  }),
  watch: {
    vid() {
      this.reload();
    },
  },
  computed: {
    vid() {
      return this.$store.state.vid;
    },
  },
  methods: {
    reload() {
      let loader = this.$loading.show();
      api
        .get('vendors')
        .then(r => {
          this.vendors = r.data;
          loader.hide();
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.reload();
            }
          }
        });
    },
    addVendor() {
      this.mode = 'insert';
      this.dialog = true;
    },
    editVendor() {
      this.config = this.selected[0];
      this.mode = 'edit';
      this.dialog = true;
    },
    insertVendor() {
      let loader = this.$loading.show();
      api
        .post('vendors', this.config)
        .then(r => {
          this.vendors.unshift(r.data);
          loader.hide();
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.insertVendor();
            }
          }
        });
    },
    updateVendor() {
      let loader = this.$loading.show();
      api
        .put('vendors/' + this.config.id, this.config)
        .then(r => {
          this.config = r.data;
          this.selected = [];
          loader.hide();
          this.dialog = false;
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.updateVendor();
            }
          }
        });
    },
    deleteVendor() {
      let loader = this.$loading.show();
      api
        .delete('vendors/' + this.selected[0].id)
        .then(r => {
          this.vendors.splice(
            this.vendors.findIndex(v => v.id == this.selected[0].id),
            1,
          );
          this.selected = [];
          loader.hide();
          this.dialog = false;
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.deleteVendor();
            }
          }
        });
    },
    updateSlots() {
      this.$nextTick(() => {
        this.config.timeslots.push(...this.timeslot.split(','));
        this.$nextTick(() => {
          this.timeslot = '';
        });
      });
    },
  },
  created() {
    api
      .get('vendors/')
      .then(r => {
        this.vendors = r.data;
      })
      .catch(async err => {
        if (err.message == 'Network Error') {
          const res = await this.$dialog.confirm({
            text: 'Please check your internet connection and try again',
            title: 'Connection Failed',
            actions: [
              { text: 'Cancel', color: 'primary', key: false },
              { text: 'Retry', color: 'primary', key: true },
            ],
          });
          if (res) {
            this.reload();
          }
        }
      });
    this.headers = [
      {
        sortable: false,
        text: '',
        value: '',
      },
      {
        sortable: false,
        text: 'id',
        value: 'id',
      },
      {
        sortable: false,
        text: 'Name',
        value: 'app_name',
      },
      {
        sortable: false,
        text: 'Type',
        value: 'type',
      },
      {
        sortable: false,
        text: 'Phone Number',
        value: 'phoneNumber',
      },
      {
        sortable: false,
        text: 'E Mail',
        value: 'email',
      },
    ];
  },
};
</script>
